import { 
  FETCH_LOGIN_SUCCESS,
  FETCH_RENEW_PASSWORD_SUCCESS
} from '../actions/auth_actions'
import { 
  FETCH_RESOURCE_ERROR 
} from '../actions/auxiliar_actions'

export default function(state = {token: null}, { type, payload }){
//   console.log(payload) { type, payload }
    switch(type){
    case FETCH_LOGIN_SUCCESS:
      return {...state, token: payload}
    case FETCH_RENEW_PASSWORD_SUCCESS:
      return {...state, token: payload, fetchError: null}
    case FETCH_RESOURCE_ERROR: {
        return {...state, fetchError: payload, loading: false}}
    default: 
      return state;
    }
}